import React from "react";

function Spinner() {
  return (
    <div className="spinner display-flex align-items-c justify-content-c">
      <div className="spin"></div>
    </div>
  );
}

export default Spinner;
